import React, { useEffect, useContext } from "react";
import useForm from 'react-hook-form';
import moment from "moment";
import ReactTable from "react-table";
import { useTranslation } from 'react-i18next';
import CsvDownloader from 'react-csv-downloader';
import { Link } from "react-router-dom";

// @material-ui/core components
import TextField from '@material-ui/core/TextField';
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import Close from "@material-ui/icons/Close";
import AddIcon from '@material-ui/icons/Add';
import Checkbox from "@material-ui/core/Checkbox";
import InputAdornment from '@material-ui/core/InputAdornment';

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import { ValidSelect } from "beaktShared/helpers/validselect";
import Select from 'react-select';
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import { transformValueFloattoFormated, transformValueFormatedtoFloat, MaskMoney, MaskCel, MaskCPF, MaskDate, formateDate, validateDate, convertDate } from "beaktShared/helpers/masks";
import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from "@material-ui/core/Tooltip";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";
import Timeline from "beaktShared/components/Timeline/Timeline.js";

// icons
import Assignment from '@material-ui/icons/Assignment';
import Search from "@material-ui/icons/Search";
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import MoneyIcon from '@material-ui/icons/Money';
import MoneyOffIcon from '@material-ui/icons/MoneyOff';
import AnnouncementIcon from '@material-ui/icons/Announcement';
import Check from "@material-ui/icons/Check";
import TurnedInNot from "@material-ui/icons/TurnedInNot";
import LoadingIcon from "@material-ui/icons/Cached";
import Edit from "@material-ui/icons/Edit";
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';


// Outros components
import SweetAlert from "react-bootstrap-sweetalert";

// services
import { SessionContext } from "beaktShared/services/session";
import { UseGetApiSimple, UsePostApi, UsePutApi, UsePostApiFile } from "beaktShared/services/crudeApiService";

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import styles2 from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
import { noCaseSensitive } from "beaktShared/helpers/extras";

const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});


export default function GestaoLeads(history) {
    const { t } = useTranslation();
    const session = useContext(SessionContext);
    const classes = useStyles();
    const classes2 = useStyles2();

    const { register, setValue, errors, setError, clearError, getValues, handleSubmit } = useForm({ mode: "onChange" });
    const [loading, setloading] = React.useState(false);
    const [loadingTable, setloadingTable] = React.useState(false);

    const [notification, setNotification] = React.useState({
        show: false,
        color: 'info',
        message: ''
    });
    const showNotification = (message, color) => {
        setNotification({
            show: true,
            color: color,
            message: message
        });
        setTimeout(function () {
            setNotification(prev => ({ ...prev, show: false }));
        }, 6000);
    };

    const [alert, setalert] = React.useState();
    const showAlert = (message, tipo) => {
        setalert(<SweetAlert
            error={tipo === 'error' ? true : false}
            warning={tipo === 'warning' ? true : false}
            success={tipo === 'success' ? true : false}
            title="Aviso"
            onConfirm={() => setalert(null)}
        >
            <div dangerouslySetInnerHTML={{ __html: message }} />
        </SweetAlert>);
    };

    const [showModal, setshowModal] = React.useState(false);
    const [showModalHistorico, setshowModalHistorico] = React.useState(false);
    const [showModalImportar, setshowModalImportar] = React.useState(false);
    const [BtnLeadHistorico, setBtnLeadHistorico] = React.useState(true);

    const [mesaniversario, setmesaniversario] = React.useState(null);
    const [listSelectMesAniversario] = React.useState([
        { value: null, text: "Todos" },
        { value: "01", text: "Janeiro" },
        { value: "02", text: "Fevereiro" },
        { value: "03", text: "Março" },
        { value: "04", text: "Abril" },
        { value: "05", text: "Maio" },
        { value: "06", text: "Junho" },
        { value: "07", text: "Julho" },
        { value: "08", text: "Agosto" },
        { value: "09", text: "Setembro" },
        { value: "10", text: "Outubro" },
        { value: "11", text: "Novembro" },
        { value: "12", text: "Dezembro" }
    ])
    const handleMesAniversarioChange = (event) => {
        let value = event
        setmesaniversario(value);
    }

    useEffect(() => {
        let dtIni = formateDate(moment(new Date()).add(-30, 'days'));
        let dtfim = formateDate(new Date());
        setValue('dataCadastroDeFilter', dtIni);
        setValue('dataCadastroAteFilter', dtfim);
        setTimeout(function () {
            handlePesquisar();
        }, 1000)

        handleTotais();
    }, [])

    const [totais, settotais] = React.useState(null);
    const handleTotais = () => {
        UseGetApiSimple("clientes/totaislead/" + session.estabelecimentoId, 0).then(result => {
            if (result.status !== 200) {
                return false;
            }
            settotais(result.data);
        });
    }

    const [list, setlist] = React.useState([])

    const handlePesquisar = () => {
        let values = getValues();

        var dataCadastroDe_date = null
        var dataCadastroAte_date = null;

        if (values.dataCadastroDeFilter !== "") {
            if (!validateDate(values.dataCadastroDeFilter)) {
                return setError("dataCadastroDeFilter", "invaliddate", t('error_message.invalid_date'))
            }
            var dataCadastroDe_date = convertDate(values.dataCadastroDeFilter);
        }

        if (values.dataCadastroAteFilter !== "") {
            if (!validateDate(values.dataCadastroAteFilter)) {
                return setError("dataCadastroAteFilter", "invaliddate", t('error_message.invalid_date'))
            }
            var dataCadastroAte_date = convertDate(values.dataCadastroAteFilter);
        }

        let data = {
            estabelecimentoId: session.estabelecimentoId,
            nome: values.nomeFilter,
            inicio: dataCadastroDe_date,
            fim: dataCadastroAte_date,
            mesaniversario: mesaniversario
        }
        setloadingTable(true);
        UsePostApi("clientes/filterleads", data).then(result => {
            if (result.status !== 200) {
                showNotification(result.message, 'danger');
                setloadingTable(false);
                return false;
            }

            setlist(result.data);

            setloadingTable(false);
        });
    }

    const [itemEdit, setitemEdit] = React.useState(null);
    const openDialog = (item) => {

        clearError("cpf");
        setitemEdit(item);

        setValue("id", 0);
        setValue("cpf", "");
        setValue("nome", "");
        setValue("email", "");
        setValue("celular", "");
        setValue("dataNascimento", "");

        if (item != null) {
            // se esse openDialog foi chamado pelo Modal de importar Leads vai usar os dados abaixo
            if (item.dadosLead != null) {
                setValue("id", item.dadosLead.clienteId);
                setValue("cpf", item.dadosLead.cpf);
                setValue("nome", item.dadosLead.nome);
                setValue("email", item.dadosLead.email);
                setValue("celular", item.dadosLead.celular);
                setValue("dataNascimento", formateDate(item.dadosLead.dataNascimento));
            } else {
                setValue("id", item.clienteId);
                setValue("cpf", item.cpf);
                setValue("nome", item.nome);
                setValue("email", item.email);
                setValue("celular", item.celular);
                setValue("dataNascimento", formateDate(item.dataNascimento));
            }
        }

        setshowModal(true);
        setshowModalImportar(false);
    }
    // Abre modal para importar os Leads
    const openModalImportar = () => {

        setshowModalImportar(true);
        setBtnLeadHistorico(false);
    }
    const CloseModalImportar = () => {

        setshowModalImportar(false);
        setBtnLeadHistorico(true);
    }
    //Campos da planilha para importar    
    const [listCSV, setlistCSV] = React.useState([]);
    const columnsCSV = [
        { displayName: "CPF", id: "cpf" },
        { displayName: "Nome", id: "nome" },
        { displayName: "DataNascimento", id: "DataNascimento" },
        { displayName: "Email", id: "email" },
        { displayName: "Celular", id: "celular" },
    ];

    const [file, set_file] = React.useState(null);
    const handleChangeImportarArquivo = (event) => {
        if (event.target.files.length > 0) {
            console.log(event.target.files[0]);
            set_file(event.target.files[0]);
        }
    }

    const ImportCSV = () => {

        setloading(true);

        var formData = new FormData();
        formData.append("file", file);

        convertDate(formData.dataNascimento);

        UsePostApiFile("clientes/importLead/" + session.id + "/" + session.estabelecimentoId, formData).then(result => {
            setloading(false);
            if (result.status !== 200 && result.status !== 201) {
                showNotification(result.message, 'danger');
                return false;
            }
            // console.log(result.data);
            setlistCSV(result.data);
            setValue("arquivo", "");
            showNotification("Importação realizada com sucesso!", 'success');

            handlePesquisar();

            setloading(false);

            return true;
        });


    }

    const [loadingValidateCPF, setloadingValidateCPF] = React.useState(false);
    const [validateCPF, setvalidateCPF] = React.useState(false);
    const handleCPFChange = e => {
        let cpf = e.target.value;
        validaExisteCPFAPI(cpf);
    }
    const validaExisteCPFAPI = (cpf) => {
        const promise = new Promise((resolve, reject) => {
            if (cpf === "")
               return resolve(false);

            let data = getValues()

            setloadingValidateCPF(true);
            const endPoint = "clientes/vefifycpf/" + cpf + "/" + parseInt(data.id);
            UseGetApiSimple(endPoint, 0).then(result => {
                if (result.status !== 200) {
                    showNotification(result.message, 'danger');
                    setloadingValidateCPF(false);
                    resolve(false);
                }
                setvalidateCPF(result.data);
                if (result.data) {
                    setError("cpf", "invalidcpf", t('error_message.cpf_already_existing') + ".");
                    setloadingValidateCPF(false);
                    resolve(true);
                }
                else
                    clearError("cpf");

                setloadingValidateCPF(false);
                resolve(false);
            });
        });
        return promise;
    }

    const [checkPendenteRetorno, setcheckPendenteRetorno] = React.useState(false);

    const openDialogHistorico = (item) => {
        setshowModalImportar(false);
        setValue("dadosContato", "");
        setcheckPendenteRetorno((item.statusLead == 1 ? true : false));
        setitemEdit(item);
        setloading(true);
        UseGetApiSimple("clientes/historicolead/" + item.clienteId + "/" + session.estabelecimentoId, 0).then(result => {
            if (result.status !== 200) {
                showNotification(result.message, 'danger');
                setloading(false);
                return false;
            }
            handleHistorico(result.data, false);
            setshowModalHistorico(true);
            setloading(false);
        });

    }

    const [rowshistorico, setrowshistorico] = React.useState([]);
    const [historico, sethistorico] = React.useState([]);
    const handleHistorico = (rows, add) => {
        let stories = [];
        let dados = rows;
        if (add === true)
            dados = [...rows, ...rowshistorico];

        var bside = false;

        for (var i = 0; i < dados.length; i++) {
            bside = bside ? false : true;

            var dtag = formateDate(dados[i].dataCadastro);

            var sto = {
                inverted: bside ? true : false,
                badgeColor: "info",
                titleColor: "info",
                badgeIcon: TurnedInNot,
                title: dados[i].tipoAcao,
                body: (
                    <div>
                        <b>Data:</b> {dtag}
                        <br /><b>OBS:</b> {dados[i].observacoes}
                        <br /><br />
                        <div style={{ fontSize: '11px', textAlign: 'right' }}>
                            <b>POR: {dados[i].usuario.nome}</b>
                        </div>
                    </div>
                )
            };
            stories.push(sto);
        }
        sethistorico(stories);
        setrowshistorico(dados);
    }

    const handleAddHistorico = () => {
        let values = getValues();

        if (values.dadosContato === "") {
            return setError("dadosContato");
        }

        let historico = {
            clienteId: itemEdit.clienteId,
            observacoes: values.dadosContato,
            usuarioCadastroId: session.id,
            tipoAcao: (checkPendenteRetorno === true ? "Aguardando Retorno" : "Contato com o Lead"),
            estabelecimentoId: session.estabelecimentoId
        }

        itemEdit.statusLead = (checkPendenteRetorno === true ? 1 : 0);

        setloading(true);
        UsePostApi("clientes/savehistoricolead", historico).then(result => {
            if (result.status !== 200) {
                showNotification(result.message.message, 'danger');
                setloading(false);
                return false;
            }
            setValue("dadosContato", "");

            const itemresult = [result.data];
            handleHistorico(itemresult, true);
            handleTotais();

            const updateList = list.map(l => (l.clienteId === itemEdit.clienteId ? itemEdit : l));
            setlist(updateList);

            setloading(false);
            showNotification("Histórico adicionado com sucesso!", 'success');
            return true;

        });
    }

    const onSubmit = (data, e) => {

        e.preventDefault();

        validaExisteCPFAPI(data.cpf).then(result => {
            if (result)
                return;

            var dataNasC = "";
            if (data.dataNascimento !== "") {
                if (!validateDate(data.dataNascimento)) {
                    return setError("dataNascimento", "invaliddate", t('error_message.invalid_date'))
                }
                var dataNasC = convertDate(data.dataNascimento);
            }

            if (data.email === "" && data.celular === "") {
                showNotification("Informe o Email ou Celular para contato com o Lead!", 'danger');
                return false;
            }

            var cliente = {
                clienteId: parseInt(data.id),
                nome: data.nome,
                cpf: data.cpf,
                dataNascimento: dataNasC,
                email: data.email,
                celular: data.celular,
                usuarioCadastroId: session.id,
                lead: true
            }

            var estabelecimentoClientes = [
                {
                    clienteId: (itemEdit != null ? itemEdit.clienteId : 0),
                    estabelecimentoId: session.estabelecimentoId
                }
            ];
            var cliente = { ...cliente, estabelecimentoClientes };

            var verifyInsert = false;
            if (cliente.clienteId === 0)
                verifyInsert = true;

            const endPoint = 'clientes/';
            if (!verifyInsert) {
                cliente.statusLead = itemEdit.statusLead;
                setloading(true);
                UsePutApi(endPoint, cliente.clienteId, cliente).then(result => {
                    if (result.status !== 200) {
                        showNotification(result.message.message, 'danger');
                        setloading(false);
                        return false;
                    }

                    const updateList = list.map(l => (l.clienteId === cliente.clienteId ? cliente : l));
                    setlist(updateList);

                    setloading(false);
                    setshowModal(false);
                    showNotification(result.message, 'success');
                    return true;
                });
            }
            else {
                cliente.statusLead = 0;
                setloading(true);
                UsePostApi(endPoint + "createlead", cliente).then(result => {
                    if (result.status !== 201) {
                        showNotification(result.message.message, 'danger');
                        setloading(false);
                        return false;
                    }
                    const addItemList = [...list, result.data];
                    setlist(addItemList);

                    setshowModal(false);
                    showNotification(result.message, 'success');
                    handlePesquisar();
                    setloading(false);

                    return true;

                });
            }
        })
    }
    //colunas do modal de importação de leads via planilha

    const columnsImport = [
        {
            Header: t('label.cpf'),
            accessor: "dadosLead.cpf",
        },
        {
            Header: t('label.name'),
            accessor: "dadosLead.nome",
        },
        {
            Header: t('label.email'),
            accessor: "dadosLead.email",
        },
        {
            Header: t('label.cell_phone'),
            accessor: "dadosLead.celular",
        },
        {
            Header: "Mensagem",
            accessor: "mensagem",
        }
    ]
    const columnsProps = [
        {
            Header: t('label.name'),
            accessor: "nome",
        },
        {
            Header: t('label.cell_phone'),
            accessor: "celular",
        },
        {
            Header: t('label.email'),
            accessor: "email",
        },
        {
            Header: "Status",
            accessor: "statusLead",
            Cell: (props) => {
                switch (props.value) {
                    case 0:
                        return "Pendente de Contato";
                    case 1:
                        return "Aguardando Retorno";
                    case 2:
                        return "Agendado";
                    default:
                        return "Virou Cliente";
                }
            }
        },
        {
            Header: t('lead.registration_date'),
            accessor: "dataCadastro",
            Cell: (props) => {
                const custom_date = formateDate(props.value)
                return <span>{custom_date}</span>
            }
        },
    ]
    const columnsAcao = [
        {
            Header: "Ações",
            Cell: row => (
                <div className="actions-right">
                    {BtnLeadHistorico
                        &&
                        <Button
                            justIcon round simple color="info"
                            onClick={() => openDialogHistorico(row.original)}
                        >
                            <Tooltip title={t('label.detail')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                                <Search />
                            </Tooltip>
                        </Button>
                    } {""}

                    <Button
                        justIcon
                        round
                        simple
                        color="success"
                        className="edit"
                        onClick={() => openDialog(row.original)}
                    >
                        <Tooltip title={t('label.to_edit')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                            <Edit />
                        </Tooltip>
                    </Button>{" "}
                </div>
            ),
            sortable: false,
            filterable: false
        }
    ];

    let columns = [...columnsProps, ...columnsAcao];
    let columnsImportsGroup = [...columnsImport, ...columnsAcao];

    return (
        <div>
            <GridContainer>

                {alert}

                {notification.show &&
                    <Snackbar
                        place="tr"
                        color={notification.color}
                        message={notification.message}
                        open={notification.show}
                        closeNotification={() => setNotification(prev => ({ ...prev, show: false }))}
                        close
                    />
                }

                {loading &&
                    <div className="carregandoCmp">
                        <div className="box">
                            <label>{t('label.loading')}...</label>
                            <CircularProgress />
                        </div>
                    </div>
                }
                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <Assignment />
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>{t('sidebar.leads')} </h4>
                        </CardHeader>
                        <CardBody>
                            <GridContainer>
                                <GridItem xs={12} sm={12} md={3}>
                                    <div className="subTitulo" style={{ marginBottom: "10px" }}>
                                        <h6>{t('label.actions')}</h6>
                                    </div>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <Button fullWidth color="primary" onClick={() => openDialog(null)}>
                                            <AddIcon></AddIcon>{t('lead.add_lead')}
                                        </Button>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <Button fullWidth color="primary" onClick={() => openModalImportar()}>
                                            <AddIcon></AddIcon>{t('label.import_leads')}
                                        </Button>
                                    </GridItem>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={9}>
                                    <div className="subTitulo" style={{ marginBottom: "10px" }}>
                                        <h6>{t('lead.indicators')}</h6>
                                    </div>
                                    <GridContainer>
                                        <GridItem xs={6} sm={6} md={6} lg={3}>
                                            <div className="cardT">
                                                <div>
                                                    <h5>
                                                        {totais != null ? totais.totalPendenteContato : 0}
                                                    </h5>
                                                </div>
                                                <div className="ico">
                                                    <Assignment style={{ fontSize: '35px' }} />
                                                </div>
                                                <div style={{ clear: 'both' }}></div>
                                                <label>{t('lead.pending_contact')}</label>
                                            </div>
                                        </GridItem>
                                        <GridItem xs={6} sm={6} md={6} lg={3}>
                                            <div className="cardT">
                                                <div>
                                                    <h5>
                                                        {totais != null ? totais.totalPendenteRetorno : 0}
                                                    </h5>
                                                </div>
                                                <div className="ico">
                                                    <Assignment style={{ fontSize: '35px' }} />
                                                </div>
                                                <div style={{ clear: 'both' }}></div>
                                                <label>{t('lead.return_pending')}</label>
                                            </div>
                                        </GridItem>
                                        <GridItem xs={6} sm={6} md={6} lg={3}>
                                            <div className="cardT">
                                                <div>
                                                    <h5>
                                                        {totais != null ? totais.totalAgendado : 0}
                                                    </h5>
                                                </div>
                                                <div className="ico">
                                                    <Assignment style={{ fontSize: '35px' }} />
                                                </div>
                                                <div style={{ clear: 'both' }}></div>
                                                <label>{t('lead.scheduled')} </label><br /><br />
                                            </div>
                                        </GridItem>
                                        <GridItem xs={6} sm={6} md={6} lg={3}>
                                            <div className="cardT">
                                                <div>
                                                    <h5>
                                                        {totais != null ? totais.totalVirouCliente : 0}
                                                    </h5>
                                                </div>
                                                <div className="ico">
                                                    <Assignment style={{ fontSize: '35px' }} />
                                                </div>
                                                <div style={{ clear: 'both' }}></div>
                                                <label>{t('lead.became_customer')} </label><br /><br />
                                            </div>
                                        </GridItem>
                                    </GridContainer>
                                </GridItem>
                            </GridContainer>
                            <br />
                            <div className="subTitulo">
                                <h6>{t('lead.list_leads')}</h6>
                            </div>
                            <GridContainer>
                                <GridItem xs={12} sm={6} md={6}>
                                    <FormControl fullWidth className={classes.formControl}>
                                        <TextField
                                            label={t('label.name')}
                                            variant="outlined"
                                            inputRef={register({ required: false })}
                                            name="nomeFilter"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={3}>
                                    <FormControl fullWidth className={classes.formControl}>
                                        <TextField
                                            error={errors.dataCadastroDeFilter ? true : false}
                                            variant="outlined"
                                            label={t('lead.registration_date_of')}
                                            name="dataCadastroDeFilter"
                                            inputRef={register({ required: false })}
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{ inputComponent: MaskDate }}
                                        />
                                        {errors.dataCadastroDeFilter &&
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.dataCadastroDeFilter && <span className="obg"> {errors.dataCadastroDeFilter.message}</span>}
                                            </FormHelperText>
                                        }
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={3}>
                                    <FormControl fullWidth className={classes.formControl}>
                                        <TextField
                                            error={errors.dataCadastroAteFilter ? true : false}
                                            variant="outlined"
                                            label={t('lead.registration_date_until')}
                                            name="dataCadastroAteFilter"
                                            inputRef={register({ required: false })}
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{ inputComponent: MaskDate }}
                                        />
                                        {errors.dataCadastroAteFilter &&
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.dataCadastroAteFilter && <span className="obg"> {errors.dataCadastroAteFilter.message}</span>}
                                            </FormHelperText>
                                        }
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={3}>
                                    <FormControl fullWidth className={classes.formControl}>
                                        <label className={errors.mesaniversario ? "select__label select__label_error" : "select__label"}>{t('lead.birthday_month')}</label>
                                        <Select
                                            classNamePrefix="select"
                                            styles={ValidSelect(errors.mesaniversario ? true : false)}
                                            isSearchable={true}
                                            name="mesaniversario"
                                            placeholder="Selecione..."
                                            options={listSelectMesAniversario}
                                            value={listSelectMesAniversario.filter(({ value }) => value === mesaniversario)}
                                            getOptionLabel={({ text }) => text}
                                            getOptionValue={({ value }) => value}
                                            onChange={(value) => handleMesAniversarioChange(value.value)}
                                            ref={() => register({ name: "mesaniversario" })
                                            }
                                        />
                                        {errors.fornecedor &&
                                            <FormHelperText>
                                                <span className="obg"> Selecione um Fornecedor </span>
                                            </FormHelperText>}
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={2}>
                                    <Button round color="primary"
                                        onClick={() => handlePesquisar()}>
                                        {t('label.search')}
                                    </Button>
                                </GridItem>
                            </GridContainer>
                            <ReactTable
                                loading={loadingTable}
                                data={list}
                                columns={columns}
                                filterable
                                defaultFilterMethod={noCaseSensitive}
                                defaultPageSize={10}
                                minRows={5}
                                showPaginationBottom={true}
                                className="-striped -highlight"
                                previousText='Anterior'
                                nextText='Próximo'
                                loadingText='Carregando...'
                                noDataText='Nenhum registro encontrado!'
                                pageText='Página'
                                ofText='de'
                                rowsText='linhas'
                            />
                        </CardBody>
                    </Card>
                </GridItem>
                <Dialog
                    classes={{ root: classes.center + " " + classes.modalRoot, paper: classes.modal + ' ' + classes.modalLarge }}
                    open={showModal}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={() => setshowModal(false)}
                    aria-labelledby="classic-modal-slide-title"
                    aria-describedby="classic-modal-slide-description"
                >
                    <DialogTitle
                        id="classic-modal-slide-title"
                        disableTypography
                        className={classes.modalHeader}
                        style={{ background: '#5c4477' }}
                    >
                        <Button
                            justIcon
                            className={classes.modalCloseButton}
                            key="close"
                            aria-label="Close"
                            color="transparent"
                            onClick={() => setshowModal(false)}
                        >
                            <Close className={classes.modalClose} />
                        </Button>
                        <h4 className={classes.modalTitle} style={{ color: 'white' }}>Lead</h4>
                    </DialogTitle>
                    <DialogContent id="classic-modal-slide-description"
                        className={classes.modalBody}
                    >
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <input className={classes.hidden} defaultValue={0} name="id" ref={register} />
                            <br />
                            <div className="subTitulo" style={{ marginBottom: "10px" }}>
                                <h6>{t('sidebar.contact_information')}</h6>
                            </div>
                            <br />
                            <GridContainer>
                                <GridItem xs={12} sm={12} md={3}>
                                    <FormControl fullWidth className={classes.formControl}>
                                        <TextField
                                            error={errors.cpf ? true : false}
                                            label="CPF"
                                            variant="outlined"
                                            onBlur={handleCPFChange}
                                            inputRef={register({ required: false })}
                                            name="cpf"
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{
                                                inputComponent: MaskCPF,
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        {loadingValidateCPF && <LoadingIcon className="rotate" />}
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                        {errors.cpf &&
                                            <FormHelperText className={classes.labelRootError}>
                                                <span>{errors.cpf.message} </span>
                                            </FormHelperText>}
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={6}>
                                    <FormControl fullWidth className={classes.formControl}>
                                        <TextField
                                            error={errors.nome ? true : false}
                                            label={t('label.name')}
                                            variant="outlined"
                                            inputRef={register({ required: true })}
                                            name="nome"
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{ maxLength: 100 }}
                                        />
                                        <FormHelperText className={classes.labelRootError}>
                                            {errors.nome && <span>{t('label.required')}</span>}
                                        </FormHelperText>
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={3}>
                                    <FormControl fullWidth className={classes.formControl}>
                                        <TextField
                                            error={errors.dataNascimento ? true : false}
                                            variant="outlined"
                                            label={t('label.date_of_birth')}
                                            name="dataNascimento"
                                            inputRef={register({ required: false })}
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{ inputComponent: MaskDate }}
                                        />
                                        {errors.dataNascimento &&
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.dataNascimento && <span className="obg"> {errors.dataNascimento.message}</span>}
                                            </FormHelperText>
                                        }
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={5}>
                                    <FormControl fullWidth className={classes.formControl}>
                                        <TextField
                                            label="Email"
                                            variant="outlined"
                                            name="email"
                                            inputRef={register({ required: false })}
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{ maxLength: 50 }}
                                        />
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={3}>
                                    <FormControl fullWidth className={classes.formControl}>
                                        <TextField
                                            label={t('label.cell_phone')}
                                            variant="outlined"
                                            name="celular"
                                            inputRef={register({ required: false })}
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{
                                                inputComponent: MaskCel,
                                            }}
                                        />
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={12}>
                                    <center>
                                        <Button type="submit" color="primary">
                                            {t('button.to_save')}
                                        </Button>
                                    </center>
                                    <br />
                                </GridItem>
                            </GridContainer>
                        </form>
                    </DialogContent>
                </Dialog>
                <Dialog
                    classes={{ root: classes.center + " " + classes.modalRoot, paper: classes.modal + ' ' + classes.modalLarge }}
                    open={showModalHistorico}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={() => setshowModalHistorico(false)}
                    aria-labelledby="classic-modal-slide-title"
                    aria-describedby="classic-modal-slide-description"
                >
                    <DialogTitle
                        id="classic-modal-slide-title"
                        disableTypography
                        className={classes.modalHeader}
                        style={{ background: '#5c4477' }}
                    >
                        <Button
                            justIcon
                            className={classes.modalCloseButton}
                            key="close"
                            aria-label="Close"
                            color="transparent"
                            onClick={() => setshowModalHistorico(false)}
                        >
                            <Close className={classes.modalClose} />
                        </Button>
                        <h4 className={classes.modalTitle} style={{ color: 'white' }}>{t('label.historic')}</h4>
                    </DialogTitle>
                    <DialogContent id="classic-modal-slide-description"
                        className={classes.modalBody}
                    >
                        <div className="subTitulo" style={{ marginBottom: "10px" }}>
                            <h6>{t('lead.include_contact_history')}</h6>
                        </div>
                        <br />
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={6}>
                                <FormControl fullWidth className={classes.formControl}>
                                    <TextField
                                        error={errors.dadosContato ? true : false}
                                        label={t('lead.include_contact_history')}
                                        variant="outlined"
                                        name="dadosContato"
                                        inputRef={register({ required: false })}
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{ maxLength: 500 }}
                                    />
                                    <FormHelperText className={classes.labelRootError}>
                                        {errors.dadosContato && <span>{t('label.required')}</span>}
                                    </FormHelperText>
                                </FormControl>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={4}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            tabIndex={-1}
                                            checked={checkPendenteRetorno}
                                            onClick={event => { setcheckPendenteRetorno(event.target.checked) }}
                                            checkedIcon={<Check className={classes.checkedIcon} />}
                                            icon={<Check className={classes.uncheckedIcon} />}
                                            classes={{
                                                checked: classes.checked,
                                                root: classes.checkRoot
                                            }}
                                            name="pendenteRetorno"
                                            inputRef={register}
                                        />
                                    }
                                    classes={{
                                        label: classes.label,
                                        root: classes.labelRoot
                                    }}
                                    label={t('lead.waiting_for_lead_return')}
                                />
                                <br /><br />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={2}>
                                <Button type="button" color="primary" onClick={() => handleAddHistorico()}>
                                    {t('label.add')}
                                </Button>
                            </GridItem>
                        </GridContainer>
                        <Timeline stories={historico} />
                    </DialogContent>
                </Dialog>
            </GridContainer>
            <Dialog
                classes={{ root: classes.center + " " + classes.modalRoot, paper: classes.modal + ' ' + classes.modalLarge }}
                open={showModalImportar}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => CloseModalImportar()}
                aria-labelledby="classic-modal-slide-title"
                aria-describedby="classic-modal-slide-description"
            >
                <DialogTitle
                    id="classic-modal-slide-title"
                    disableTypography
                    className={classes.modalHeader}
                    style={{ background: '#5c4477' }}
                >
                    <Button
                        justIcon
                        className={classes.modalCloseButton}
                        key="close"
                        aria-label="Close"
                        color="transparent"
                        onClick={() => setshowModalImportar(false)}
                    >
                        <Close className={classes.modalClose} />
                    </Button>
                    <h4 className={classes.modalTitle} style={{ color: 'white' }}>{t('label.lead_management')}</h4>
                </DialogTitle>
                <GridContainer style={{ width: '100%' }}>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card style={{ boxShadow: '0px 0px' }}>
                            <CardHeader color="primary" icon>
                                <CardIcon color="primary">
                                    <PlaylistAddCheckIcon />
                                </CardIcon>
                                <h4 className={classes.cardIconTitle}>
                                    {t('label.import_file')}
                                </h4>
                            </CardHeader>
                            <CardBody>
                                <GridContainer style={{ width: '100%' }}>
                                    <GridItem xs={12} sm={8} md={8}>
                                        <FormControl fullWidth className={classes2.formControl}>
                                            <TextField
                                                error={errors.arquivo ? true : false}
                                                type="file"
                                                label={t('label.file') + " *"}
                                                variant="outlined"
                                                name="arquivo"
                                                InputLabelProps={{ shrink: true }}
                                                onBlur={(event) => handleChangeImportarArquivo(event)}
                                            />
                                            <CsvDownloader
                                                filename="report"
                                                columns={columnsCSV}
                                                datas={[]}
                                                separator={";"}>
                                                <Button round color="info" size="sm">Download Modelo</Button>
                                            </CsvDownloader>
                                            <span>{"Atenção: Preencher na planilha os campos obrigatórios. Nome, Email ou Celular"}</span>
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={4} md={4}>
                                        <center>
                                            <Button fullWidth color="primary" onClick={() => ImportCSV()}>
                                                <AddIcon></AddIcon>{t('label.import')}
                                            </Button>
                                        </center>
                                    </GridItem>
                                </GridContainer>
                                {listCSV.length > 0 &&
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <div className="subTitulo" style={{ marginTop: '20px' }}>
                                                <h6>{t('conciliation.result_import')}</h6>
                                            </div>
                                            <ReactTable
                                                loading={loading}
                                                data={listCSV}
                                                filterable
                                                defaultFilterMethod={noCaseSensitive}
                                                columns={columnsImportsGroup}
                                                defaultPageSize={10}
                                                minRows={5}
                                                showPaginationBottom={true}
                                                className="-striped -highlight"
                                                previousText={t('button.previous')}
                                                nextText={t('button.next')}
                                                loadingText={t('label.loading') + "..."}
                                                noDataText={t('information_message.no_records_found') + "!"}
                                                pageText={t('label.page')}
                                                ofText={t('label.of')}
                                                rowsText={t('label.rows')}
                                            />
                                        </GridItem>
                                    </GridContainer>
                                }
                            </CardBody>

                        </Card>
                    </GridItem>
                </GridContainer>
            </Dialog>

        </div>
    );
}